<template>
  <StateAnalysis
    title="情绪评价报告"
    report="qxReportHistories"
  ></StateAnalysis>
</template>

<script>
import StateAnalysis from "./state.vue";
export default {
  components: {
    StateAnalysis,
  },
  computed: {},
  methods: {},
};
</script>

<style >
</style>